@if (submitting) {
  <app-loading message="Creating your {{ 'organisation' | ize }}">
  </app-loading>
}

@if (!submitting) {
  <app-standard-page>
    <app-standard-page-content [limitWidth]="true">
      <div class="card-body">
        <div class="row mt-4">
          <div class="col-12">
            <h1 class="text-primary">
              Create your {{ 'organisation' | ize }} here
            </h1>

            <p>
              Creating a new {{ 'organisation' | ize }} for a brand new account?
              Fill in the details below.
            </p>

            <p>
              Looking for an existing {{ 'organisation' | ize }} or register?
              The {{ 'organisation' | ize }} owner will need to invite you
              first.
            </p>
          </div>
        </div>
        <form [formGroup]="form" (validSubmit)="onSubmit()">
          <div class="row form-section">
            <div class="col col-lg-5">
              <app-form-control margin="small" [columnLayout]="true">
                <app-form-label>
                  {{ 'Organisation' | ize }} Name *
                </app-form-label>
                <input
                  data-dd-action-name="create-first-organisation.name-input"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="
                    form.controls.name.touched && form.controls.name.invalid
                  "
                  formControlName="name"
                />
                @if (form.controls.name.hasError('required')) {
                  <div class="invalid-feedback">Name is required</div>
                }
                @if (form.controls.name.getError('maxlength'); as error) {
                  <div class="invalid-feedback">
                    Name must be less than {{ error.requiredLength }} characters
                  </div>
                }
              </app-form-control>

              <app-form-control margin="small" [columnLayout]="true">
                <app-form-label [required]="true">Country</app-form-label>
                <select
                  data-dd-action-name="create-first-organisation.country-select"
                  class="form-select"
                  formControlName="countryId"
                  [class.is-invalid]="
                    form.controls.countryId.touched &&
                    form.controls.countryId.invalid
                  "
                >
                  @for (country of countries; track country) {
                    <option [ngValue]="country.id">
                      {{ country.name }}
                    </option>
                  }
                </select>
              </app-form-control>

              <button
                data-dd-action-name="create-first-organisation.create-button"
                type="submit"
                class="btn btn-primary"
              >
                <i-lucide name="plus"></i-lucide>
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </app-standard-page-content>
  </app-standard-page>
}
